import { Component, OnInit, ViewChild } from "@angular/core";
import { MasterService } from "src/app/Shared/app.Masters.Service";
import { LmsService } from "../services/lms.service";
import * as moment from "moment";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { CommonFunctions } from "../../CommonComponent/function/commonfunctions";
@Component({
    selector: "app-receipt-detail",
    templateUrl: "./receipt-detail.component.html",
    styleUrls: ["./receipt-detail.component.scss"],
    standalone: false
})
export class ReceiptDetailComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  chargesHeadDropdown: any;
  ChargesHead: any = "0";
  CaseNo: any;
  datefrom: any = new Date();
  dateto: any = new Date();
  Receipt_Type: any = "All";
  ReceiptDatasource: any;
  JsonData: any[] = [];
  showSpinner = false;
  DisplayedColumn: any[];
  currentUser: any;
  constructor(
    private _MasterService: MasterService,
    private _LMSService: LmsService,
    private dataSharingService: DataSharingService,
    private commonFunctions: CommonFunctions
  ) {}

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("Receipt Book Details");
    this.getChargesHead();
  }

  getChargesHead() {
    this._MasterService
      .GetProductChargesHeadDropDown()
      .subscribe((res: any) => {
        console.log("Charges Head", res);

        this.chargesHeadDropdown = res;
      });
  }

  getReceiptBookDetails() {
    this.showSpinner = true;
    let requestModel = {
      FromDate: moment(this.datefrom).format("YYYY-MM-DD"),
      ToDate: moment(this.dateto).format("YYYY-MM-DD"),
      Receipt_Type: this.Receipt_Type,
      CaseNo: this.CaseNo,
      ChagesHead: this.ChargesHead,
      LoginUserId: this.currentUser.userId,
    };
    this._LMSService
      .LMS_Receipt_detail(requestModel)
      .subscribe((response: any) => {
        if (response.length > 0) {
          this.DisplayedColumn = [
            "Number",
            "ReceiptNo",
            "Voucher_Date",
            "ReceiptDate",
            "CaseNo",
            "Customer_Name",
            "ChagesHead",
            "Account_Name",
            "Branch_Name",
            "Amount",
            "TranType",
            "Voucher_CreateBy",
            "Collection_Executive",
            "Collection_By",
            "Origin",
            "location",
            "Voucher_Narration",
            "Voucher_Tag",
            "Voucher_Type",
          ];
          this.JsonData = response;
          console.log("json Data response", this.JsonData);
          this.ReceiptDatasource = new MatTableDataSource(response);
          this.ReceiptDatasource.paginator = this.paginator;
          this.showSpinner = false;
        } else {
          this.ReceiptDatasource = null;
          this.showSpinner = false;
        }
      });
  }

  totaltypewise(type) {
    if (this.ReceiptDatasource != null) {
      let sum = 0;
      for (let i = 0; i < this.ReceiptDatasource.filteredData.length; i++) {
        sum += Number(this.ReceiptDatasource.filteredData[i][type]);
      }
      return sum > 0 ? sum.toFixed(2) : 0;
    }
    return 0;
  }

  exportexcelNew(): void {
    const worksheetName = "RECEIPT BOOK DETAILS";
    this.commonFunctions.exportHtmlTableToExcel(
      "receipt_details",
      `${worksheetName}.xls`,
      worksheetName
    );
  }

  applyFilter(filterValue: string) {
    this.ReceiptDatasource.filter = filterValue.trim().toLowerCase();
  }
}
